
<template>
  <div class="mf_fp_opt_form_container">
    <div class="test">
      <form class="mf_fp_opt_form" method="POST" :action="route">
        <b-col cols="12">
          <div class="title">
            Partagez votre adresse email pour obtenir les résultats
          </div>
          <div class="subTitle">
            Vous pourrez ainsi enregistrer et comparer vos différents
            portefeuilles !
          </div>
          <b-form-input
            required
            placeholder="Prénom"
            name="firstName"
            type="text"
          />
          <b-form-input required placeholder="Nom" name="name" type="text" />
          <b-form-input
            required
            placeholder="Votre email"
            name="email"
            type="email"
          />
          <input
            type="hidden"
            id="portfolio"
            name="portfolio"
            :value="portfolio"
          />
          <input type="hidden" name="_token" :value="token" />
          <div class="btnDiv">
            <b-button type="submit"
              >Accéder à mon portefeuille optimisé</b-button
            >
          </div>
        </b-col>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["portfolio", "token", "route"]
};
</script>
<style lang="scss" scoped>
@import "../../../../../../../resources/sass/_variables.scss";

.mf_fp_opt_form_container {
  background: white;
  min-height: 100vh;

  .test {
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
  }
  .mf_fp_opt_form {
    background: $bg_color;
    border-radius: 30px;
    padding: 20px;
    text-align: left;
    width: 80% !important;
    .title {
      color: $mf_ft_color_lt;
      font-weight: bold;
      font-size: 2.2em;
    }
    .subTitle {
      color: $mf_ft_color_lt;
      font-size: 1em;
      margin-top: 15px;
    }
    .form-control {
      margin-top: 40px;
      background: transparent;
      border-top: none !important;
      border-left: none !important;
      border-right: none !important;
      font-size: 20px !important;
      color: $mf_ft_color_lt;
      width: 90%;
      margin-left: auto;
      margin-right: auto;
    }

    .btnDiv {
      text-align: center;
      button {
        border-radius: 30px;
        border: none;
        background: $purple_color;
        padding: 8px;
        margin-top: 40px;
        margin-bottom: 20px;
        box-shadow: $boxShadow;
        width: 70%;
      }
    }
  }
}
</style>